export class RegisterForm {
    company:string;
    companyregnum:string;
    vatnum:string;
    profile:string;
    firstname:string;
    lastname:string;
    email:string;
    mobilenum:string;
    phonenum:string;
    faxnum:string;
    address:string;
    zip:string;
    city:string;
    country:string;
    // currency:string;
    // language:string;
    // dateformat:string;
    constructor(){}

}
